import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FolderKanban } from "lucide-react";
import { clientApi } from "@/lib/api";

const STATUS_LABEL = { active: "En cours", completed: "Terminé", on_hold: "En pause" };
const STATUS_COLOR = { active: "bg-blue-100 text-blue-700", completed: "bg-green-100 text-green-700", on_hold: "bg-gray-100 text-gray-700" };

export default function ClientProjects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => { clientApi.get("/client/projects").then(({ data }) => setProjects(data)); }, []);

  return (
    <div className="space-y-6" data-testid="client-projects">
      <h1 className="font-heading font-black text-3xl text-[#0B1F3A]">Mes projets</h1>
      <div className="grid md:grid-cols-2 gap-4">
        {projects.length === 0 && (
          <div className="md:col-span-2 bg-white rounded-xl p-12 text-center border border-gray-200">
            <FolderKanban className="h-12 w-12 text-gray-300 mx-auto mb-3" />
            <p className="text-[#4B5563]">Aucun projet pour l'instant.</p>
          </div>
        )}
        {projects.map((p) => {
          const totalTasks = (p.tasks || []).length;
          const doneTasks = (p.tasks || []).filter((t) => t.status === "done").length;
          const progress = totalTasks ? Math.round((doneTasks / totalTasks) * 100) : 0;
          const pendingDeliv = (p.deliverables || []).filter((d) => d.status === "pending").length;
          return (
            <Link key={p.id} to={`/portail/projets/${p.id}`} className="block bg-white rounded-xl p-6 border border-gray-200 hover:border-[#00B8D9] hover:shadow-md transition-all">
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-heading font-bold text-lg text-[#0B1F3A]">{p.name}</h3>
                <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_COLOR[p.status]}`}>{STATUS_LABEL[p.status] || p.status}</span>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">{p.description || "—"}</p>
              <div className="space-y-2 mb-4">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-[#4B5563]">Avancement</span>
                  <span className="font-bold text-[#0B1F3A]">{progress}%</span>
                </div>
                <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                  <div className="h-full bg-[#00B8D9] transition-all" style={{ width: `${progress}%` }} />
                </div>
              </div>
              <div className="flex items-center justify-between text-sm">
                <div className="text-[#4B5563]">{totalTasks} tâche(s) · {(p.deliverables || []).length} livrable(s)</div>
                {pendingDeliv > 0 && <span className="bg-[#00B8D9]/10 text-[#00B8D9] text-xs font-bold px-2 py-1 rounded-full">{pendingDeliv} à valider</span>}
              </div>
              <div className="mt-3 text-sm font-semibold text-[#00B8D9] flex items-center gap-1">Ouvrir <ArrowRight className="h-4 w-4" /></div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
